// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3mISu","info":"UpdateTermsInfo_info__ptQ0Y"};